import React, { useState } from 'react'
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
    CircularProgress,
} from '@material-ui/core'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'

import { makeStyles } from '@material-ui/core/styles'
import history from 'history.js'
import clsx from 'clsx'
import useAuth from 'app/hooks/useAuth'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    root:{
      borderRadius:10
    },
    button: {
        // backgroundColor: '#3c52b2',
        color: '#cacaca',
        '&:hover': {
            backgroundColor: '#fff',
            color: '#a101e5',
        }},
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        maxWidth: 800,
        borderRadius: 16,
        margin: '1rem',
        boxShadow:"0px 0px 13px 3px #eeeeee"
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}))

const JwtLogin = () => {
    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        email: '',
        password: '',
    })
    const [message, setMessage] = useState('')
    const { login } = useAuth()

    const classes = useStyles()

    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo }
        temp[name] = value
        setUserInfo(temp)
    }

    const handleFormSubmit = async (event) => {
        setLoading(true)
        try {
            await login(userInfo.email, userInfo.password)
            history.push('/')
        } catch (e) {
            console.log(e)
            setMessage(e.message)
            setLoading(false)
        }
    }

    return (
        <div
            className={clsx(
                'flex justify-center items-center  min-h-full-screen',
                // classes.cardHolder
            )}
        >
            <Card className={classes.card} style={{minWidth:300}}>
                <div style={{ textAlign: 'center', fontSize: '50px', fontFamily: 'Cocomat', marginTop: '10%' }}>
                    pixel<span style={{ color: '#9400d3' }} >crm</span>
                </div>
                <Grid container>
                    {/*<Grid item lg={5} md={5} sm={5} xs={12}>*/}
                    {/*    <div className="p-8 flex justify-center items-center h-full">*/}
                    {/*        <img*/}
                    {/*            className="w-200"*/}
                    {/*            src="/assets/images/illustrations/dreamer.svg"*/}
                    {/*            alt=""*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</Grid>*/}
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="p-8 h-full relative border-radius-15">
                            <ValidatorForm onSubmit={handleFormSubmit}>
                                <TextValidator
                                    className="mb-6 w-full br-15"
                                    // className={{root: classes.root}}
                                    // Style={'border-radius: 15px;'}
                                    // style={{borderRadius:"15px "}}
                                    // classes={classes.MuiOutlinedInput}
                                    // classes={{root:{borderRadius:15}}}
                                    InputProps={{
                                        classes:{
                                            root: classes.root
                                        }
                                    }}
                                    variant="outlined"
                                    size="small"
                                    label="Почта"
                                    // placeholder="Логин"
                                    onChange={handleChange}
                                    type="email"
                                    name="email"
                                    value={userInfo.email}
                                    validators={['required', 'isEmail']}
                                    errorMessages={[
                                        'Поле обязательно для заполнения',
                                        'Введите корректный email',
                                    ]}
                                />
                                <TextValidator
                                    className="mb-3 w-full "
                                    label="Пароль"
                                    // placeholder="Пароль"
                                    InputProps={{
                                        classes:{
                                            root: classes.root
                                        }
                                    }}
                                    variant="outlined"
                                    size="small"
                                    onChange={handleChange}
                                    name="password"
                                    type="password"
                                    value={userInfo.password}
                                    validators={['required']}
                                    errorMessages={['Поле обязательно для заполнения']}
                                />
                                <FormControlLabel
                                    className="mb-3 min-w-288"
                                    name="agreement"
                                    style={{display:"none"}}
                                    onChange={handleChange}
                                    control={
                                        <Checkbox
                                            size="small"
                                            onChange={({
                                                target: { checked },
                                            }) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement',
                                                        value: checked,
                                                    },
                                                })
                                            }
                                            checked={userInfo.agreement || true}
                                        />
                                    }
                                    label="Запомнить"
                                />

                                {message && (
                                    <p className="text-error">{message}</p>
                                )}

                                <div className="flex flex-wrap items-center mb-4" style={{ justifyContent: 'center', marginTop: '15px' }}>
                                    <div className="relative">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={loading}
                                            type="submit"
                                        >
                                            Вход
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <span className="mr-2 ml-5">или</span>
                                    <Button
                                        className="capitalize"
                                        onClick={() =>
                                            history.push('/session/signup')
                                        }
                                    >
                                        Регистрация
                                    </Button>
                                </div>
                                <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                <Button
                                    // className="text-disabled"
                                    className={classes.button}
                                    style={{ justifyContent: 'center'}}
                                    onClick={() =>
                                        history.push('/session/forgot-password')
                                    }
                                >
                                    Забыли пароль?
                                </Button>
                                <Button
                                    className={classes.button}
                                    style={{ justifyContent: 'center' }}
                                    onClick={() =>
                                        history.push('/others/tariffs')
                                    }
                                >
                                    Тарифы
                                </Button>
                                <Button className={classes.button} onClick={() => history.push('/help')}>
                                    База знаний
                                </Button>
                                </div>
                            </ValidatorForm>
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </div>
    )
}

export default JwtLogin
